import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Hinweisflaeche (MUI-`Alert`-Ersatz) auf Basis der `.sec-alert`-Klassen.
 * `role="alert"` nur bei Fehlern/Warnungen (assertiv), sonst `status` (polite).
 */
export const Alert = forwardRef(function Alert({ severity = 'info', title, className, children, ...rest }, ref) {
    const assertive = severity === 'error' || severity === 'warning';
    return (_jsx("div", { ref: ref, role: assertive ? 'alert' : 'status', className: cn('sec-alert', `sec-alert--${severity}`, className), ...rest, children: _jsxs("div", { className: "sec-alert__content", children: [title != null && _jsx("strong", { children: title }), children != null && _jsx("div", { children: children })] }) }));
});
